import authApi from './index';

/****
 *Request - {
  "clubID": "string",
  "meetID": "string",
  "eventType": "string",
  "ageGroup": "string",
  "gender": "string",
  "roundType": "string",
  "roundNumber": 0,
  "surfaceType": "string" // "Synthetic" or "Grass" - do not include for Shot Put or Discus
}
 */
export const addEvent = async (payload) => {
  return await authApi.post(`/events`, payload);
};

export const getAgeEvents = async (clubID, meetID) => {
  return await authApi.post('/meet-age-results/get-age-events', {
    clubID,
    meetID,
  });
};

export const getEvents = async (clubID, meetID) => {
  return await authApi.post('/meet-events/get-events', {
    clubID,
    meetID,
  });
};

export const getEventById = async (eventID) => {
  return await authApi.get(`/events/${eventID}`);
}

/****
 *Request - {
  "eventID": "string",
  "clubID": "string",
  "meetID": "string",
  "eventType": "string",
  "eventTypeCode": 0,
  "ageGroup": "string",
  "gender": "string",
  "roundType": "string",
  "roundNumber": 0,
  "surfaceType": "string",
}
 */
export const updateEvent = async (payload) => {
  return await authApi.put('/events', payload);
}